'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _snakeToSpace = require('./snakeToSpace.filter');

var _snakeToSpace2 = _interopRequireDefault(_snakeToSpace);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var snakeToSpaceModule = _angular2.default.module('snakeToSpace.filter', []).filter('snakeToSpace', _snakeToSpace2.default).name;

exports.default = snakeToSpaceModule;


// WEBPACK FOOTER //
// ./client/app/common/filters/snakeToSpaceService/snakeToSpace.js